export default __webpack_public_path__ + "static/media/wow xl collage.6c6fe3e5.png";